(function () {
  function bindSidebarToggle(section) {
    const toggle = section.querySelector('.pebble-collection__sidebar-toggle');
    if (!toggle || toggle.dataset.pebbleSidebarBound) return;

    toggle.dataset.pebbleSidebarBound = 'true';
    toggle.addEventListener('click', () => {
      const isHidden = section.classList.toggle('is-sidebar-hidden');
      toggle.setAttribute('aria-expanded', isHidden ? 'false' : 'true');
    });
  }

  function syncFilterAccordion(details) {
    details.classList.toggle('is-expanded', details.open);
  }

  function bindFilterAccordions(root) {
    const scope = root || document;
    scope.querySelectorAll(
      '.pebble-collection__sidebar-aside .filters__disclosure, .pebble-collection__sidebar-aside .pebble-sidebar__categories-disclosure'
    ).forEach((details) => {
      if (details.dataset.pebbleAccordionBound) {
        syncFilterAccordion(details);
        return;
      }

      details.dataset.pebbleAccordionBound = 'true';
      syncFilterAccordion(details);
      details.addEventListener('toggle', () => syncFilterAccordion(details));
    });
  }

  function init(root) {
    const scope = root || document;
    scope.querySelectorAll('.main-collection--pebble.has-collection-sidebar').forEach((section) => {
      bindSidebarToggle(section);
      bindFilterAccordions(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('reloadfilter', () => {
    init();
  });
})();
